import { render, staticRenderFns } from "./IconShare.vue?vue&type=template&id=1675e752&"
import script from "./IconShare.vue?vue&type=script&lang=ts&"
export * from "./IconShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports